import { render, staticRenderFns } from "./dialogOrgGroupTree.vue?vue&type=template&id=2d4f1e61&"
import script from "./dialogOrgGroupTree.vue?vue&type=script&lang=js&"
export * from "./dialogOrgGroupTree.vue?vue&type=script&lang=js&"
import style0 from "./dialogOrgGroupTree.vue?vue&type=style&index=0&id=2d4f1e61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports